import React from 'react';

import Section from '../section';
import SummaryItem from '../summary-item';

const classes = {
  sectionReset: '',
};

const ProjectsList = ({ projects }) => {
  return (
    <Section
      title="Side Projects"
      className={classes.sectionReset}
    >
      <p className='italic text-sm mb-6'>
        Some projects are public, others private as I consider productizing or refactoring - all solo-built experiments in rapid prototyping, UX, and self-hosted deployment.
      </p>
      <hr className='mb-6'/>
      {projects.map((project) => (
        <SummaryItem
          key={project.name}
          name={project.name}
          description={project.description}
          link={project.link}
          github={project.github}
        />
      ))}
    </Section>
  );
};

export default ProjectsList;
